// extracted by mini-css-extract-plugin
module.exports = {"container":"_24slm","titleContainer":"_1ZBzx","title":"JKXug","contentWrapper":"_3HqCu","content":"L9sO0","arrow":"nwibF","arrowUp":"_2HZ-L"};